import { FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';
import COLOR3 from '@zola/zola-ui/src/styles/emotion/colors3';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

const SummarySection = styled.section`
  &&& {
    margin-bottom: ${SPACING.MD};
  }
`;

export const HeaderStyles = css`
  font-family: ${FONT.FONT_FAMILY_CIRCULAR};
  font-weight: ${FONT.FONT_WEIGHT_REGULAR};
  font-size: ${FONT.FONT_SIZE_SMALL}; // 16 px
  line-height: ${SPACING.S24};
  color: ${COLOR3.BLACK_050};

  margin: 0;
  margin-bottom: ${SPACING.XXS};
`;

/**
 * The header, possibly with a pencil edit icon that appears at the top
 * of each section in the rapid repeat inquiry summary.
 */
export const Header = styled.label<{
  canEdit?: boolean;
}>`
  &&& {
    ${HeaderStyles}

    position: relative;
    display: flex;
    ${({ canEdit }) => {
      if (canEdit) {
        return css`
          padding-right: 20px;
        `;
      }
      return css``;
    }}

    button {
      padding: ${SPACING.SM};
      top: -${SPACING.SM};
      right: -${SPACING.SM};
      border-radius: 50%;
      position: absolute;

      :hover {
        background-color: ${COLOR3.BLACK_005};
      }
    }
  }
`;

export const AlertNotice = styled.div`
  &&& {
    display: flex;
    align-items: center;
  }
`;

/**
 * Default styles for a section of the rapid repeat inquiry summary screen when
 * the section is in _view_ mode.
 */
export const ViewSection = styled.section`
  &&& {
    color: ${COLOR3.BLACK_100};
  }
`;

/** Default styles for a section of the rapid repeat inquiry summary screen when
 * the section is in _edit_ mode.
 */
export const EditSection = styled.section`
  display: block;
`;

export const RequiredNotice = styled.div`
  color: ${COLOR3.ROSE_100};
  margin-left: 2px;
`;

const SummarySectionStyles = {
  Header,
  ViewSection,
  EditSection,
  SummarySection,
  AlertNotice,
  RequiredNotice,
};

export default SummarySectionStyles;
